import { render } from "./PointOfCare.vue?vue&type=template&id=541337de&scoped=true"
import script from "./PointOfCare.vue?vue&type=script&lang=js"
export * from "./PointOfCare.vue?vue&type=script&lang=js"

import "./PointOfCare.vue?vue&type=style&index=0&id=541337de&scoped=true&lang=css"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541337de"]])

export default __exports__